import { ModalLayout, Text, useMainContext } from '..'
import { useGetUserStake } from '../core/services'
import { ReactComponent as PiggyIcon } from '../../../components/common/icons/piggy.svg'
import { useMemo } from 'react'

const DetailsModal = ({ open, onClose, data }) => {
	const {
		main: { lang },
	} = useMainContext()
	const { data: stake } = useGetUserStake(data?._id)

	const profitPc = useMemo(() => {
		if (!!stake) {
			return ((stake.settlementsPaid || 0) / stake.settlements) * 100 || 5
		}
		return 0
	}, [stake])

	return (
		<ModalLayout padding={'0px'} open={open} onClose={onClose} width={'700px'}>
			<div className={'rounded-md  dark:text-slate-100'}>
				<div
					className={
						'h-[52px] lg:h-[64px] w-full rounded-t-md  flex items-center justify-center'
					}
				>
					<Text tid={'staking-detail'} className={'lg:text-base text-sm'} />
				</div>

				<div className={'p-3 lg:p-5 flex flex-col gap-3 text-sm'}>
					<div className={'grid grid-cols-6 lg:grid-cols-12 gap-3'}>
						<div
							className={
								'col-span-6 rounded-md dark:bg-dStakingDetailsCard p-3 flex flex-col gap-3'
							}
						>
							<div className={'w-full flex items-center justify-between gap-2'}>
								<div className={'flex items-center gap-1'}>
									<PiggyIcon />
									<Text tid={'staking-all-profit'} />
								</div>

								<div className={'text-xs'}>
									{new Date().toLocaleString(lang === 'fa' ? 'fa-IR' : 'en-US')}
								</div>
							</div>

							<div className={'flex justify-end'}>
								<span dir={'ltr'} className={'text-xl'}>
									{stake?.amountPaid} {stake?.currency?.toUpperCase()}
								</span>
							</div>
						</div>

						<div className={'col-span-6 rounded-md dark:bg-dStakingDetailsCard p-3'}>
							<div>
								<Text tid={'staking-profit-process'} />
							</div>
							<div className={'flex justify-end'}>
								<Text tid={'remaining'} className={'dark:text-slate-300 text-xs'} />
							</div>
							<div
								className={
									'rounded-lg h-[18px] mt-1 bg-slate-300 dark:bg-dOnCardBg w-full relative'
								}
							>
								<div
									className={'h-full absolute right-0 top-0 bg-active rounded-lg'}
									style={{ width: `${profitPc}%` }}
								>
									<div
										className={'h-[5px] rounded-[50%] absolute w-[5px] left-1 top-[6px] bg-white'}
									/>
								</div>
							</div>
							<div
								className={'text-[0.675rem] mx-2 flex mt-[1px] items-center justify-between gap-2'}
							>
								<span>
									<span>30</span>
									<span> </span>
									<Text tid={'day'} />
								</span>
								<span>
									<span>{30 * stake?.settlements}</span>
									<span> </span>
									<Text tid={'day'} />
								</span>
							</div>
						</div>
					</div>

					<div
						className={
							'dark:bg-secondaryBg bg-slate-200 rounded-md w-full px-5 py-3 flex items-center justify-between'
						}
					>
						<Text tid={'income-profit'} />
						<Text tid={'date'} />
					</div>

					{stake?.history?.length ? (
						stake.history.map((h) => {
							return (
								<div
									key={h.at}
									className={
										'flex items-center justify-between border-b-[1px] border-gray-500 border-opacity-20 px-5 py-2'
									}
								>
									<span dir={'ltr'}>
										<span>{h.amount}</span>
										<span> </span>
										<span>{stake?.currency?.toUpperCase()}</span>
									</span>
									<span dir={'ltr'}>
										{new Date(h.at).toLocaleString(lang === 'fa' ? 'fa-IR' : 'en-US')}
									</span>
								</div>
							)
						})
					) : (
						<div className={'min-h-[144px] w-full flex items-center justify-center flex-col gap-3'}>
							<img
								src={require('../../../assets/images/noData.png')}
								alt={'no-data'}
								width={92}
								height={92}
							/>
							<Text tid={'no-profit-yet'} />
						</div>
					)}
				</div>
			</div>
		</ModalLayout>
	)
}

export default DetailsModal
